<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input 
          label="Description " 
          style="width:400px">
          <el-input
            :rows="2"
            v-model="serviceRequest.comments"
            type="textarea"
            placeholder="Please input"
          />
        </base-input>
      </div>
    </div>
    <base-button 
      md 
      type="primary" 
      @click="onSubmit()">Save</base-button>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
  data: () => {
    return {};
  },

  computed: {
    ...mapGetters({
      statusList: "status/getStatusList",
      serviceRequest: "serviceRequest/getServiceRequest"
    }),
    ...mapState("serviceRequest", ["serviceRequest"])
  },

  mounted() {
    this.getStatusList();
  },

  methods: {
    ...mapActions({
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      getStatusList: "status/getStatusList",
      getServiceRequestList: "serviceRequest/getServiceRequestList",
      updateServiceRequest: "serviceRequest/updateServiceRequest"
    }),
    ...mapMutations({
      setServiceRequest: "serviceRequest/setServiceRequest"
    }),
    onSubmit() {
      const newStatus = this.statusList.find(i => i.code === "cancelled");
      this.serviceRequest.statusId = newStatus.statusId;
      this.updateServiceRequest().then(res => {
        this.$notify({
          message: "Service Request Updated Succesfully!",
          type: "success",
          title: "Succes"
        });
        this.getServiceRequestList();
        this.$emit("close");
      });
    }
  }
};
</script>